<template>
    <kt-panel>
        <div class="accordion accordion-toggle-arrow" id="userCatFilter">
            <div class="card" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div class="card-title collapsed" data-toggle="collapse"
                         data-target="#catFilterForm"
                         aria-controls="catFilterForm">
                        {{ $t('label.search') }}
                    </div>
                </div>
                <div id="catFilterForm" class="collapse" aria-labelledby="catFilterForm" data-parent="#userCatFilter">
                    <div class="card-body">
                        <form @submit.prevent="action($event, query)">
                            <kt-form-section>
                                <kt-form-row>
                                    <kt-col xs="12" sm="4" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="cat_name">
                                                {{ $t('label.cat_name') }}
                                            </kt-form-label>
                                            <kt-form-control ref="cat_name"
                                                             dir="ltr"
                                                             name="cat_name"
                                                             id="cat_name"
                                                             v-model="query.title"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="4" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="from_date">
                                                {{ $t('label.from_date') }}
                                            </kt-form-label>
                                            <datePicker
                                                format="YYYY-MM-DD HH:mm:ss"
                                                display-format="dddd jDD jMMMM jYYYY"
                                                input-class="form-control"
                                                :clearable="true"
                                                v-model="query.from_date" type="date"/>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="4" md="4">
                                        <div class="form-group">
                                            <label for="category_status">{{ $t('label.status') }}</label>
                                            <select class="form-control"
                                                    id="category_status"
                                                    name="category_status"
                                                    ref="category_status"
                                                    v-model="query.category_status"
                                            >
                                                <option value="1"></option>
                                                <option value="2">{{ $t('label.active') }}</option>
                                                <option value="3">{{ $t('label.deleted') }}</option>
                                            </select>
                                        </div>
                                    </kt-col>
                                </kt-form-row>
                            </kt-form-section>
                            <kt-form-section>
                                <kt-row>
                                    <kt-col xs="12" sm="6" md="6">
                                        <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                                    </kt-col>
                                </kt-row>
                            </kt-form-section>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </kt-panel>
</template>

<script>

export default {
    props: {
        action: {
            default: function(e, query) {},
            required: true,
        }
    },
    data() {
        return {
            query: {},
        }
    },
    methods: {
        clearCreatedAt() {
            if(this.query.from_date) {
                this.query.from_date = null
            }
        },
    }
}
</script>